import CustomRessourceSearch from '@/models/ressourcesSearch/CustomRessourceSearch'
import Speciality from '@/models/entities/Speciality'
import Surgeon from '@/models/entities/Person/Surgeon'

/**
 * Custom Ressource Search for Surgeon
 */
class DoctorRessourceSearch extends CustomRessourceSearch<Surgeon, Speciality> {
   filter(): Surgeon[] {
      const filtered = super.filter()

      if (!this.dependOn || this.dependOn.length !== 1 || !this.dependOn[0].selectedRessource) {
         return filtered
      }

      const speciality = this.dependOn[0].selectedRessource

      return filtered.filter((doctor: Surgeon) => {
         return doctor.specialities.some((docSpec: Speciality) => {
            return docSpec.id === speciality.id
         })
      })
   }
}

export default DoctorRessourceSearch
